var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable max-len */
import React from "react";
import BaseSvgIcon from "./Base";
var CircleHollow = function (props) {
    return (React.createElement(BaseSvgIcon, __assign({ width: "20px", height: "20px", viewBox: "0 0 20 20" }, props),
        React.createElement("g", { stroke: "none", fillRule: "evenodd" },
            React.createElement("circle", { id: "Oval", cx: "10", cy: "10", r: "3", strokeWidth: "1", stroke: "#00ADEE", fill: "none" }))));
};
export default CircleHollow;
